// extracted by mini-css-extract-plugin
export var cardIcon = "_94-5";
export var cardIconUnframed = "_94-9";
export var checkboxCard = "_94-0";
export var checkboxCardSelected = "_94-4";
export var disabled = "_94-2";
export var interactive = "_94-1";
export var outerBorder = "_94-3";
export var spacerMedium = "_94-8";
export var spacerSmall = "_94-7";
export var spacerXsmall = "_94-6";